import { useDataChange } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.statements.new',
    viewPath: props.viewPath,
  })

  return function onChange(next) {
    if (!next) return

    change(next)
  }
}
